import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';

import { ENDPOINT } from '../../types/edit-user-address';

import { HttpMethod } from '@/shared/contracts/http-client.contract';

type UseCaseInput = {
  address_id: string;
};

type UseCaseOutput = void;

export class DeleteUserAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { address_id } = input;

    if (!address_id) {
      throw new Error('User address id is required');
    }

    const response = await this.client.sendRequest<UseCaseOutput, void>({
      method: HttpMethod.DELETE,
      endpoint: ENDPOINT(address_id),
    });

    return response;
  }
}
